import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {map, take} from 'rxjs/operators';

export const authenticatedGuard = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const oidcService = inject(OidcSecurityService);

  return oidcService.isAuthenticated$.pipe(
    take(1),
    map(({isAuthenticated}) => {
      if (!isAuthenticated) {
        // Store the intended URL and trigger OIDC login
        sessionStorage.setItem('returnUrl', state.url);
        oidcService.authorize();
        return false;
      }
      return true;
    })
  );
};
